module.exports = __webpack_public_path__ + "static/media/2DGACM2.e7ae287d.jpg";